import React, { useEffect, useState } from 'react';
import Collapse from '../../../../../../../../hoc/Collapse/Collapse';
import FormulaireListesObjetsRapport from '../../FormulaireListeObjetsRapport';
import styles from './BoiteRapport.module.scss';

const BoiteRapport = ({
  preconfigureObjet,
  gererJson,
  contenuEnTete,
  project_id,
  affichageProfil,
  children,
}) => {
  const [reportObjectType, setReportObjectType] = useState(
    preconfigureObjet?.report_object_type || ''
  );
  const [objectsList, setObjectsList] = useState(
    preconfigureObjet?.objects_list || []
  );
  const [display, setDisplay] = useState(preconfigureObjet?.display || '');

  useEffect(() => {
    if (preconfigureObjet === undefined) {
      // Set default parameters
      setReportObjectType('');
      setObjectsList([]);
      setDisplay('');
    } else {
      // Pre-configure the form
      setReportObjectType(preconfigureObjet.report_object_type || '');
      setObjectsList(preconfigureObjet.objects_list || []);
      setDisplay(preconfigureObjet.display || '');
    }
  }, [preconfigureObjet]);

  useEffect(() => {
    const currentState = {
      report_object_type: reportObjectType,
      objects_list: objectsList,
      display: display,
    };
    gererJson(currentState);
  }, [reportObjectType, objectsList, display, gererJson]);

  const gererObject_list = (newObjectsList) => {
    setObjectsList([...newObjectsList]);
  };

  return (
    <Collapse
      showAdvanceParameters={true}
      expandText={<div className={styles.contenuEnTete}>{contenuEnTete}</div>}
    >
      {children}
      <FormulaireListesObjetsRapport
        project_id={project_id}
        gererObjectsList={gererObject_list}
        objects_list={objectsList}
        affichageProfil={affichageProfil}
        typeObjetParent={reportObjectType}
        display={display}
      />
    </Collapse>
  );
};

export default BoiteRapport;
